import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../../components/Loading";
import DropDownMenu from './Dropdown'
import _ from 'lodash'
import { getImageFileAspectRatio } from '../../../utils/util';
import { uploadPhoto } from "../../../services/documents";
import '../../../../node_modules/react-grid-layout/css/styles.css';
import '../../../../node_modules/react-resizable/css/styles.css';
import RGL, { WidthProvider } from 'react-grid-layout';
import RemoveSvg from '../../../svgs/RemoveSvg'
import FileDropzone from '../../../components/FileDropzone'
import { updatePartner } from "../../../services/partners";
import HTMLEditor from "./HTMLEditor";

const ReactGridLayout = WidthProvider(RGL);

const rowHeight = 60
const numOfRow = 5
const convertToLayout = (data) => { return data?.map((item, index) => ({ i: `${index}`, x: 0, y: index * numOfRow, w: 1, h: numOfRow, data: item })) || [] }


function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isloading, setIsloading] = useState(false)

    const onDropImageFile = (item, index) => async (files) => {
        if (files.length > 1) {
            alert(`Only one file is allowed.`)
            return
        }
        const file = files[0]
        if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
            alert(`File type ${file.type} is not allowed`)
            return
        }
        if (file.size > 1024 * 1024 * 4) {
            alert(`File size must be within 4 MB`)
            return
        }

        const aspectRatio = await getImageFileAspectRatio(file);

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, id, props.data?.[props.field]?.[index]?.id || Date.now());

        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result

                let updateData = {
                    [props.field]: props.data?.[props.field]?.map((item, i) => {
                        if (i === index) {
                            item.url = filepath
                            item.aspectRatio = aspectRatio
                        }
                        return item
                    })
                };

                if (props.save)
                    await props.save(props.token?.token, id, updateData)
                else
                    await updatePartner(props.token?.token, id, updateData)

                if (props.onEditKey) props.onEditKey(item, index, 'url', filepath)
            }
        }
        setIsloading(false);
    }

    const [layout, setlayout] = useState(convertToLayout(props.data?.[props.field] || []));
    useEffect(() => {
        //work around for issue of ReactGridLayout not updating width
        window.dispatchEvent(new Event('resize'));
    }, [layout]);
    useEffect(() => {
        setlayout(convertToLayout(props.data?.[props.field] || []))
    }, [props.data])

    const onDragStop = useCallback((layout) => (layout_, oldItem, newItem) => {
        const clonelayout = [...layout_]//_.cloneDeep(layout);
        const index = _.findIndex(layout, { 'i': oldItem.i })
        let dragY = clonelayout[index].y
        if (layout[index].y < dragY) {
            for (let i in layout) {
                if (layout[i].y <= dragY && layout[i].y > layout[index].y)
                    clonelayout[i].y = layout[i].y - 1
            }
        } else if (layout[index].y > dragY) {
            for (let i in layout) {
                if (layout[i].y >= dragY && layout[i].y < layout[index].y)
                    clonelayout[i].y = layout[i].y + 1
            }
        } else return
        clonelayout[index].y = dragY
        setlayout(clonelayout)
        if (props.updateOrder) props.updateOrder(layout, clonelayout)
    }, [layout])

    const onAddCard = () => { if (props.onAddCard) props.onAddCard() }
    const onDelete = (item, index) => () => { if (props.onDelete) { props.onDelete(item, index) } };
    const onEditKey = (item, index, key) => (e) => { if (props.onEditKey) props.onEditKey(item, index, key, e.target.value) };

    const handleSelectQuestionType = (item, index) => (type, typeIndex) => {
        if (props.onEditKey) props.onEditKey(item, index, 'type', type);
    }





    return (
        <div style={{ width: '100%', boxSizing: 'border-box' }}>
            <div className='flex flex-col w-full'>
                <div className='w-full flex flex-row w-full items-center gap-[16px] justify-between py-[2px] px-[16px] text-[14px] font-[700]'>
                    <div className='w-[20px]'></div>
                    <div className='w-[16px]'>#</div>
                    <div className='flex-1'>內容</div>
                </div>
                <ReactGridLayout
                    className='layout'
                    layout={layout}
                    cols={1}
                    rowHeight={rowHeight}
                    maxRows={layout.length * numOfRow}
                    preventCollision={true}
                    allowOverlap={true}
                    isDraggable={true}
                    isResizable={false}
                    onDragStop={onDragStop(layout)}
                    draggableHandle='.drag-handle'
                    style={{ height: layout.length * ((rowHeight + 10) * numOfRow), margin: 0, padding: 0 }}
                >
                    {layout?.map((item, index) => (
                        <div
                            key={item.i}
                            className='flex flex-row w-full items-start py-[8px] gap-[16px] justify-between px-[4px] rounded-[7px]'
                            style={{ border: '2px solid #B9B9B9', height: rowHeight }}
                        >
                            <div className='drag-handle cursor-pointer w-[20px]'>
                                <DragIcon />
                            </div>
                            <div className='w-[16px]'>{Number(index) + 1}</div>
                            <div className='flex-[1] flex flex-col gap-[8px] h-[100%]' style={{ overflowY: 'auto' }}>

                                <div className='flex flex-row w-full gap-[16px] flex-wrap'>

                                    <div className='flex flex-col'>
                                        <div className='font-[700]'>類型</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={handleSelectQuestionType(item, index)}
                                                value={props.data?.[props.field]?.[index]?.type || '--- 無 ---'}
                                                minWidth={250}
                                                options={props.isCmsEmail?[ '電郵內容','圖片','標題']:['敬語', '個人二維碼', '電郵內容','圖片']}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {props.data?.[props.field]?.[index]?.type === '電郵內容' && <div className="flex flex-col w-full">
                                    <HTMLEditor
                                        onChange={(e) => { if (props.onEditKey) props.onEditKey(item, index, (props.textField || 'data'), e.target.value) }}
                                        value={props.data?.[props.field]?.[index]?.[props.textField || 'data'] || ""}
                                    />
                                </div>}
                                {props.data?.[props.field]?.[index]?.type === '標題' && <div className="flex flex-col w-full">
                                    <input onChange={(e) => { if (props.onEditKey) props.onEditKey(item, index, (props.textField || 'data'), e.target.value) }}
                                        value={props.data?.[props.field]?.[index]?.[props.textField || 'data'] || ""}
                                        className="w-full bg-[#FFFFFF80] border-[#8D876C] border-[1px] text-black p-[8px] rounded-[7px]"
                                    />
                                </div>}
                                {props.data?.[props.field]?.[index]?.type === '敬語' && <div className="flex flex-row w-full gap-[16px]">
                                    <input onChange={
                                        (e) => { if (props.onEditKey) props.onEditKey(item, index, (props.textField || 'data'), e.target.value) }
                                    } className="w-full bg-[#FFFFFF80] border-[#8D876C] border-[1px] text-black p-[8px] rounded-[7px]" value={props.data?.[props.field]?.[index]?.[props.textField || 'data'] || ""} />
                                     <input value={'##[User Name]##'} className="w-full bg-[#FFFFFF80] border-[white] border-[1px] text-black p-[8px] rounded-[7px] bg-[#ccc]" />
                                </div>}
                                {props.data?.[props.field]?.[index]?.type === '個人二維碼' && <div className="flex flex-row w-full gap-[16px]">
                                    <input value={'##[User QR Code]##'} className="w-full bg-[#FFFFFF80] border-[white] border-[1px] text-black p-[8px] rounded-[7px] bg-[#ccc]" />
                                </div>}

                                {props.data?.[props.field]?.[index]?.type === '圖片' && <div className="flex flex-col w-full">
                                    <div className='font-[700]'>圖片寬度 (0-100)%</div>
                                    <div className='flex flex-row items-center gap-[8px]'>
                                        <input
                                            type='number'
                                            min={0}
                                            max={100}
                                            value={props.data?.[props.field]?.[index]?.width? props.data?.[props.field]?.[index]?.width.replace('%', '') :100}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (value === '') value = 0
                                                else if (value > 100) value = 100
                                                else if (value < 0) value = 0
                                                if (props.onEditKey) props.onEditKey(item, index, 'width', value + '%')
                                            }}
                                            className='w-[80px] px-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent]'
                                        />
                                        <div>%</div>
                                    </div>
                                </div>}

                                {props.data?.[props.field]?.[index]?.type === '圖片' && <div className="flex flex-col w-full">
                                    <div className="flex flex-row gap-[16px]">
                                        <div className='font-[700]'>點擊照片重新導向:</div>
                                        <input
                                            type='checkbox'
                                            checked={props.data?.[props.field]?.[index]?.allowUrlRedirect || false}
                                            onChange={(e) => {
                                                if (props.onEditKey) props.onEditKey(item, index, 'allowUrlRedirect', e.target.checked)
                                            }}
                                            className='cursor-pointer'
                                        />
                                        {props.data?.[props.field]?.[index]?.allowUrlRedirect && <div className='font-[700]ml-[24px]'>URL:</div>}
                                        {props.data?.[props.field]?.[index]?.allowUrlRedirect && <input
                                            className='w-[400px] px-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent]'
                                            placeholder="https://example.com"
                                            value={props.data?.[props.field]?.[index]?.redirectUrl || ''}
                                            onChange={onEditKey(item, index, 'redirectUrl')}
                                        />}
                                    </div>
                                    <div className='w-full flex flex-row max-w-[800px] min-w-[400px] gap-[8px] mt-[8px]'>
                                        {props.data?.[props.field]?.[index]?.url && <div className='relative w-full'>
                                            {
                                                props.data?.[props.field]?.[index]?.url
                                                    ? <img style={{ height: 'auto', width: '100%', objectFit: 'contain' }} src={props.data?.[props.field]?.[index]?.url} alt='image' />
                                                    : <div>
                                                    </div>
                                            }
                                            <div onClick={() => {
                                                if (props.onEditKey) props.onEditKey(item, index, 'url', null)
                                            }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                                <RemoveSvg />
                                            </div>
                                        </div>}
                                        <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                                            <FileDropzone onDropFile={onDropImageFile(item, index)} data={props.data?.[props.field]?.[index]} />
                                        </div>
                                    </div>
                                </div>}




                            </div>
                            <div className='cursor-pointer' onClick={onDelete(item, index)}>
                                <RemoveIcon />
                            </div>
                        </div>
                    ))}
                </ReactGridLayout>
                <div className='flex flex-row mt-[16px] p-[10px]'>
                    <div
                        className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#9f9f8b]'
                        style={{ border: '1px solid rgb(145, 151, 112)' }}
                        onClick={onAddCard}
                    >
                        <AddSvg /> 添加內容
                    </div>
                </div>
            </div>

           
            {isloading && <LoadingPage />}
        </div>
    );
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)


const AddSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={12}
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            d="M11.408 6.935h-4.5v4.5h-1.5v-4.5h-4.5v-1.5h4.5v-4.5h1.5v4.5h4.5v1.5Z"
        />
    </svg>
)



const DragIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={17}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="#000"
                d="M2 12.311h12v-1.333H2v1.333Zm0-3.333h12V7.644H2v1.334ZM2 4.31v1.333h12V4.311H2Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 .311h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
)

const RemoveIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={21}
        fill="none"
        {...props}
    >
        <path
            fill="#212121"
            d="M1.364 18.15a2.238 2.238 0 0 0 2.231 2.231h8.926a2.238 2.238 0 0 0 2.232-2.231V4.76H1.363v13.39ZM3.595 6.992h8.926V18.15H3.595V6.992Zm8.368-5.578L10.848.298h-5.58L4.154 1.414H.248v2.231h15.62V1.414h-3.905Z"
        />
    </svg>
)

function CrossIcon(props) {
    return (
        <svg
            width={21}
            height={21}
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle
                cx={10.1461}
                cy={10.1461}
                r={9.89242}
                fill="#F9FAFB"
                stroke="#111827"
                strokeWidth={0.507303}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.689 13.51a.64.64 0 11-.906-.906l2.458-2.458-2.458-2.458a.64.64 0 11.906-.906l2.458 2.458 2.458-2.458a.64.64 0 01.905.906l-2.458 2.458 2.458 2.458a.64.64 0 01-.905.905l-2.458-2.458-2.458 2.458z"
                fill="#111827"
            />
        </svg>
    )
}